import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "file-upload d-flex" }

import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    text: {}
  },
  emits: ['upload'],
  setup(__props: any, { emit: __emit }) {



const file = ref<File | null>(null)
const fileInput = ref<HTMLInputElement | null>(null)

const emits = __emit

function triggerFileInput() {
  fileInput.value?.click()
}

function handleFileChange(event: Event) {
  const target = event.target as HTMLInputElement
  const selectedFile = target.files?.[0]
  if (selectedFile) {
    file.value = selectedFile
    emits('upload', selectedFile)
  }
  target.value = ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      class: "hidden-input",
      onChange: handleFileChange,
      accept: ".xlsx"
    }, null, 544),
    _createVNode(_component_v_btn, {
      color: "primary",
      variant: "outlined",
      rounded: "",
      onClick: triggerFileInput
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          start: "",
          icon: "mdi-upload"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.text ?? '上传学生数据'), 1)
      ]),
      _: 1
    })
  ]))
}
}

})